"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function isThenable(obj) {
  return !!(obj && typeof obj.then === 'function');
}

var _default = isThenable;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hs-promise-utils/static-1.16/js/isThenable.js
// module id = 493
// module chunks = 5 6 7